export default __webpack_public_path__ + "static/media/ag-img.04fb26de.png";